export default __webpack_public_path__ + "static/media/mute_icon.d2530bf1.svg";